// extracted by mini-css-extract-plugin
export default {"component":"CheckerContentBlocks__component-_AXP","wrapper":"CheckerContentBlocks__wrapper-uapj"};